import { render, staticRenderFns } from "./RaceNotes.vue?vue&type=template&id=4a0460ca&scoped=true&"
import script from "./RaceNotes.vue?vue&type=script&lang=js&"
export * from "./RaceNotes.vue?vue&type=script&lang=js&"
import style0 from "./RaceNotes.vue?vue&type=style&index=0&id=4a0460ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0460ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
